// extracted by mini-css-extract-plugin
export default {"middleText":"NotFound_middleText__ICuCA"};